const useDeviceOrientation = () => {
    return null;
};
export default useDeviceOrientation;
